import { makeStyles, withStyles } from '@material-ui/core/styles'
import { Checkbox } from "formik-material-ui";

export const useStyles = makeStyles((theme) => ({
  editInfo: {
    fontFamily: 'Gilroy-ExtraBold, serif',
    color: '#000',
    fontSize: '1.3rem',
    marginTop: 25,
    marginBottom: 10,
  },
  forms: {
    fontFamily: 'Gilroy-ExtraBold, serif',
    color: '#000',
    fontSize: '1.2rem',
    marginTop: 20,
    marginLeft: 25,
    marginBottom: 40,
  },
  changePas: {
    fontFamily: 'Gilroy-ExtraBold, serif',
    color: '#000',
    fontSize: '1.2rem',
    marginTop: 20,
    marginLeft: 25,
    marginBottom: 40,
  },
  fieldText: {
    fontFamily: 'Gilroy-ExtraBold, serif',
    textTransform: 'capitalize',
    fontSize: '0.9rem',
    marginLeft: 30,

  },
  account: {
    width: "90%",
    marginTop: 20,
    marginLeft: 30,
    backgroundColor: "#FFFAF7",

  },
  change: {
    width: "90%",
    marginTop: 15,
    marginLeft: 30,
    backgroundColor: "#FFFAF7",
  },
  field: {
    width: "60%",
  },
  button: {
    borderRadius: '20px',
    fontFamily: 'Gilroy-Light, serif',
    textTransform: 'capitalize',
    fontSize: '14px',
    backgroundColor: '#e45826',
    color: '#fff',
    width: '160px',
    fontWeight: 400,
    height: 40,
    marginLeft: 5,
    marginRight: 5,
    '&:hover': {
      backgroundColor: '#e45826',
      boxShadow: 'none',
    },
  },
  clear: {
    borderRadius: '20px',
    fontFamily: 'Gilroy-Light, serif',
    textTransform: 'capitalize',
    fontSize: '1rem',
    borderWidth: "5px",
    borderColor: "#e45826",
    backgroundColor: '#fff',
    color: '#e45826',
    width: '160px',
    fontWeight: 400,
    height: 40,
    marginLeft: 5,
    marginRight: 5,
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: 'none',
    },
  },
  upload: {
    borderRadius: '20px',
    fontFamily: 'Gilroy-Light, serif',
    textTransform: 'capitalize',
    fontSize: '1rem',
    borderWidth: "5px",
    borderColor: "#e45826",
    backgroundColor: '#fff',
    color: '#e45826',
    width: '160px',
    fontWeight: 400,
    height: 40,
    marginTop: 30,
    marginLeft: 10,
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: 'none',
    },
  },
  alert: {
    marginTop: 5,
    marginBottom: 10,
  }
}))



const checkBoxStyles = theme => ({
  root: {
    '&$checked': {
      color: '#3D70B2',
    },
  },
  checked: {},
})

export const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);


